import { GET_ALL_SEQUENCE } from "./graphql";
import client from "../graphqlClient";
import { getGraphqlResult } from "../../Utilities/Functions";

const getAllSequences = async () => {
  const response = await client.query({
    query: GET_ALL_SEQUENCE,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getAllProcessSequence");
  return results;
};

export { getAllSequences };
